import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Brunch from './components/Brunch';
import Restaurant from './components/Restaurant';
import Bar from './components/Bar';
import About from './components/About';
import Instagram from './components/Instagram';
import Reservation from './components/Reservation';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { useSEO, generateRestaurantSchema, generateFAQSchema, generateWebPageSchema } from '@/utils/seo';

export default function Home() {
  useSEO({
    title: 'Brunch Buffet & Bar Tapas Saint Pierre La Réunion',
    description: 'Le Bokal Givré à Saint-Pierre, La Réunion : Brunch buffet sucré & salé 100% maison, restaurant tapas et bar tropical.',
    keywords: 'Brunch Saint-Pierre, La Réunion, Tapas Saint-Pierre, Bar Réunion 974 Brunch weekend, Restaurant ligne des bambous, Cuisine créole, Brunch Réunion, Meilleur brunch 974, Le Bokal Givré',
    canonical: '/',
    ogType: 'restaurant',
    ogImage: 'https://readdy.ai/api/search-image?query=tropical%20brunch%20buffet%20restaurant%20la%20reunion%20colorful%20food&width=1200&height=630&seq=og-image&orientation=landscape'
  });

  useEffect(() => {
    // Add multiple Schema.org structured data
    const schemas = [
      generateRestaurantSchema(),
      generateFAQSchema(),
      generateWebPageSchema()
    ];

    // Create a combined schema using @graph
    const combinedSchema = {
      '@context': 'https://schema.org',
      '@graph': schemas
    };

    let scriptTag = document.querySelector('script[data-schema="home"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'application/ld+json');
      scriptTag.setAttribute('data-schema', 'home');
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(combinedSchema);

    return () => {
      const tag = document.querySelector('script[data-schema="home"]');
      if (tag) {
        tag.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Brunch />
        <Restaurant />
        <Bar />
        <Reservation />
        <About />
        <Contact />
        <Instagram />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}